// extracted by mini-css-extract-plugin
export default {"feedContainer":"Step2__feedContainer___y951G","statusButtonWrapper":"Step2__statusButtonWrapper___k7NWC"};